import * as React from "react";
import { SearchableComboBox } from "src/components/base/SearchableComboBox";
import { flowstepUIControl } from "@v2/types/data";
import useDataLoader from "@v2/utils/useDataLoader";
import { DataObject } from 'shared/providers/types';


interface Props extends flowstepUIControl<DataObject[], DataObject> {
    errorMessage?: string;
    placeholder?: string;
}

const ObjectPicker: React.FC<Props> = ({ value, onChange, data, disabled, errorMessage, placeholder }) => {
    const objects = useDataLoader<DataObject[]>(data) || [];

    const objectsOptions = React.useMemo(() => objects.map(o => ({ ...o, key: o.name, text: o.label })), [objects])

    return (
        <div>
            <SearchableComboBox
                placeholder={placeholder || 'Select object'}
                selectedKey={value?.name}
                options={objectsOptions}
                onChange={(event, item) => onChange(true, item as DataObject)}
                disabled={disabled}
                errorMessage={errorMessage}
            />
        </div>
    );
};

export default ObjectPicker;
